import { Separator } from "@/components/ui/separator";
import { TeamsTable } from "./teams-table";
import { NestedPlan } from "@revelate/types";
import type { KeyedMutator } from "swr";
import { TeamsCombobox } from "./components/teams-combobox";

export default function TeamsPage({
  plan,
  mutate,
}: {
  plan: NestedPlan;
  mutate: KeyedMutator<NestedPlan | null>;
}) {
  return (
    <div className="space-y-6">
      <div className="flex">
        <div>
          <h3 className="text-lg font-medium">Teams</h3>
          <p className="text-sm text-muted-foreground">
            Connect this plan to teams to start calculating commissions.
          </p>
        </div>
        <div className="ml-auto flex items-center gap-2">
          <TeamsCombobox plan={plan} mutate={mutate} />
        </div>
      </div>
      <Separator />
      <TeamsTable plan={plan} mutate={mutate} />
    </div>
  );
}
